import {sendDataToExtension} from './extensionListener';
import * as newExtension from './messaging';
import {trackError} from '../3rdParty';

import {
  getExtensionVersion as legacyGetExtensionVersion,
  getIsExtensionAuthenticated as legacyGetIsExtensionAuthenticated,
  getIsBlueAuthenticated as legacyGetIsBlueAuthenticated,
  getUserBlueUrl as legacyGetUserBlueUrl,
} from './legacy';

const handleExtensionError = (err: unknown) => {
  trackError(new Error('Extension communication error'), {
    extras: {
      error: err,
    },
  });
  return null;
};

const withFallback =
  <T, U>(func: (input: T) => Promise<U | null>, fallback: (input: T) => Promise<U>) =>
  async (input: T) => {
    const res = await func(input).catch(handleExtensionError);
    // if res is null, it might mean the new extension communication is not supported yet, try the old one
    return res ?? (await fallback(input));
  };

export const getExtensionVersion = withFallback<void, string>(
  newExtension.getExtensionVersion,
  legacyGetExtensionVersion
);

export const getIsExtensionAuthenticated = withFallback<void, boolean>(
  newExtension.getIsExtensionAuthenticated,
  legacyGetIsExtensionAuthenticated
);

export const getIsBlueAuthenticated = withFallback<void, boolean>(
  newExtension.isBlueAuthenticated,
  legacyGetIsBlueAuthenticated
);

export const getUserBlueUrl = withFallback<void, string>(newExtension.getUserBlueUrl, legacyGetUserBlueUrl);

export const passSessionDump = withFallback(newExtension.passSessionDump, async dump => {
  sendDataToExtension('passSessionDump', JSON.stringify(dump));
  return true;
});

export const getSessionDump = () => newExtension.getSessionDump().catch(handleExtensionError);

export const logout = () => newExtension.logout().catch(handleExtensionError);
